import { WEAPONS } from '@/config/weapons';
import { NOTICE_STYLE } from '@/config/hud';
import { LOOT } from '@/config/loot';
import { WEAPON_RARITY_COLOR, weaponRarityKey } from '@/config/weapon-visuals';
import { t, type I18nKey } from '@/i18n';
import type { CrateDestination } from './shop-types';

/** Localised weapon words shared by HUD, crates, shop and notices (docs/09). */
export function weaponName(weaponId: string): string {
  const def = WEAPONS[weaponId];
  return def ? t(def.nameKey as I18nKey) : weaponId;
}

export function weaponRarityName(weaponId: string): string {
  const def = WEAPONS[weaponId];
  return def ? t(weaponRarityKey(def.rarity) as I18nKey) : '';
}

/** Text line under the icon toast: where the picked weapon went (docs/09). */
export function pickupNotice(weaponId: string, dest: CrateDestination, socket: number): string {
  const name = weaponName(weaponId);
  switch (dest) {
    case 'socket': return t('hud.pickupSocket', { name, n: socket + 1 });
    case 'bag': return t('hud.pickupBag', { name });
    case 'full': return t('hud.pickupFull', { name });
    case 'scrap': return t('hud.pickupScrap', { name, n: scrapGems(weaponId) });
  }
}

/** Yellow paid for scrapping a weapon (also: crates nobody can carry). */
export function scrapGems(weaponId: string): number {
  const def = WEAPONS[weaponId];
  return def ? LOOT.scrapValue[def.rarity] : 0;
}

/** Rare/epic pickups glow in their rarity colour; commons use the default. */
export function pickupNoticeColor(weaponId: string): number {
  const def = WEAPONS[weaponId];
  if (!def || def.rarity === 'common') return NOTICE_STYLE.pickup.color;
  return WEAPON_RARITY_COLOR[def.rarity];
}
